import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Navigation from './../Navigation/Navigation'

const LAYOUT = ['navbar', 'sidebar']
const TRIGGERS = ['hover', 'divider', 'button']
const HORIZ_ALIGN = ['center', 'start', 'end']
const POSITIONS = ['left', 'right', 'top', 'bottom']

const color = PropTypes.color
const Icon = PropTypes.Icon

const theme = {
  navBackground: color,
  navColor: color,
  navHoverColor: color,
  navActiveColor: color,
  navActiveIndicatorColor: color,
  shadow: PropTypes.string,
  rightBorder: PropTypes.string,
  toggleButtonColor: color
}

const sideBarSettings = {
  /**
   * Sidebar toggle trigger
   */
  sidebarToggleTrigger: PropTypes.oneOf(TRIGGERS),
  /**
   * Sidebar toggle trigger
   */
  triggerIcon: Icon,
  /**
   * Determines if sidebar is exoanded initialy
   */
  isSidebarExpanded: PropTypes.bool,
  /**
   * Determines if sidebar is expandable
   */
  isSidebarExpandable: PropTypes.bool,
  /**
   * Determines if sidebar collapses on route changed
   */
  autoCollapse: PropTypes.bool
}

const navBarSettings = {
  /**
   * Show labels
   */
  showLabels: PropTypes.bool,

  /**
   * Alignment of items in Navigation (horizontal layout). Left, center, or right.
   */
  horizontalAlign: PropTypes.oneOf(HORIZ_ALIGN)
}

class PageContent extends Component {
  static propTypes = {
    /**
     * Determines if the content contains navigation
     */
    showNavigation: PropTypes.bool,

    /**
     * Position of the navigation
     */
    navLayout: PropTypes.oneOf(LAYOUT),

    /**
     * Label position
     */
    labelPosition: PropTypes.oneOf(POSITIONS),

    /**
     * Show / hide icons
     */
    showIcons: PropTypes.bool,

    animated: PropTypes.bool,

    transitions: PropTypes.shape({
      enter: PropTypes.string,
      exit: PropTypes.string,
      duration: PropTypes.number
    }),

    /**
     * Sidebar settings
     */
    sidebarSettings: PropTypes.shape(sideBarSettings),

    /**
     * NavbarSettings
     */
    navbarSettings: PropTypes.shape(navBarSettings),

    /**
     * Color settings for navigation.
     */
    styling: PropTypes.shape(theme)
  }

  static defaultProps = {
    showNavigation: true,
    navLayout: 'sidebar',
    labelPosition: 'right',
    showIcons: true,
    navbarSettings: {
      horizontalAlign: 'start',
      showLabels: true
    },
    sidebarSettings: {
      sidebarToggleTrigger: 'hover',
      isSidebarExpanded: false,
      isSidebarExpandable: true
    },
    styling: {}
  }

  constructor (props) {
    super(props)
    this.state = {
      navExpanded: false
    }
    this.handleScroll = this.handleScroll.bind(this)
    this.toggleShrink = this.toggleShrink.bind(this)
    this.handleStateChange = this.handleStateChange.bind(this)
    this.navRef = React.createRef()
  }

  componentDidMount () {
    const { showNavigation, routes, history, location } = this.props

    const noTabSelected = routes && !routes.some(r => r.matchesPath(location.pathname, true))

    if (noTabSelected && !showNavigation) {
      const { route } = routes[0]
      if (route && history) {
        history.replace(route)
      }
    }
  }

  handleScroll () {
    const { scrollWidth } = this.navRef.current.refs.inner
    const { status } = this.navRef.current.state
    this.setState({
      sidebarStatus: status,
      sidebarWidth: scrollWidth
    })
  }

  toggleShrink (status) {
    this.setState({
      navExpanded: status
    })
  }

  handleStateChange () {
    const { position } = this.navRef.current.refs.inner.style
    if (this.state.sidebarStatus !== position) {
      this.setState({
        sidebarStatus: position,
        sidebarWidth: 240
      })
    }
  }

  render () {
    const {
      children,
      showNavigation,
      navLayout,
      routes,
      StickyWrapper,
      transitions,
      animated
    } = this.props
    const { navExpanded } = this.state
    const isSidebar = navLayout === 'sidebar'
    return (
      <div className={'page-content'}>
        <div className={'page-wrapper'}>
          {
            showNavigation && StickyWrapper &&
            <div className={`nav-wrapper  ${((navExpanded) && 'expanded') || ''}`}>
              <StickyWrapper
                ref={this.navRef}
                handleStateChange={this.handleStateChange}
                stack
                innerZ={1999}
                className={'stickies'}
                topTarget={'.assignment-preview'}
              >
                <div className={'navigation'}>
                  <Navigation
                    {...this.props}
                    toggleShrink={this.toggleShrink}
                    items={routes}
                    navLayout={navLayout}
                  />
                </div>
              </StickyWrapper>
            </div>
          }
          <div className={'main-content'}>
            {children}
          </div>
        </div>
        <style jsx>{`
          .page-content {
            position: relative;
            height: 100%;
            min-height: 500px;
            overflow: hidden;
          }
          .page-wrapper {
            height: 100%;
            display: flex;
            flex-direction: ${isSidebar ? 'row' : 'column'};
          }
          .nav-wrapper {
            position: relative;
            overflow: visible;
            flex: ${isSidebar ? '0 0 76px' : '0 0 auto'};
            display: inline-block;
            -webkit-transition: flex 0.25s ease-out;
            -moz-transition: flex 0.25s ease-out;
            -o-transition: flex 0.25s ease-out;
            -ms-transition: flex 0.25s ease-out;
            transition: flex 0.25s ease-out;
          }
          .nav-wrapper :global(.sticky-inner-wrapper) {
            ${(isSidebar &&
            `
          width: ${navExpanded ? '240px' : '76px'} !important;
                   -webkit-transition: width 0.25s ease-out;
                   -moz-transition: width 0.25s ease-out;
                   -o-transition: width 0.25s ease-out;
                   -ms-transition: width 0.25s ease-out;
          transition: width 0.25s ease-out;
          `) || ''}
          }
          .nav-wrapper.expanded {
            flex: 0 0 240px;
            -webkit-transition: flex 0.25s ease-out;
            -moz-transition: flex 0.25s ease-out;
            -o-transition: flex 0.25s ease-out;
            -ms-transition: flex 0.25s ease-out;
            transition: flex 0.25s ease-out;
          }
          .main-content {
            width: 100%;
            -webkit-transition: width 0.25s ease-out;
            -moz-transition: width 0.25s ease-out;
            -o-transition: width 0.25s ease-out;
            -ms-transition: width 0.25s ease-out;
            transition: width 0.25s ease-out;
          }
          .main-content > :global(div) {
            animation-duration: ${animated && transitions && transitions.duration ? (transitions.duration + 'ms') : 'unset'}
          }
          `}</style>
      </div>
    )
  }
}

export default PageContent
